import { Stack } from 'immutable';
import { createObjectSelector } from 'app/selectors';

export const modals = createObjectSelector((state) => state.modals || Stack());
